import { FilterMatchMode } from "primereact/api"
import { Button } from "primereact/button"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { Dialog } from "primereact/dialog"
import { IconField } from "primereact/iconfield"
import { InputIcon } from "primereact/inputicon"
import { InputText } from "primereact/inputtext"
import { useEffect, useState } from "react"

type IAddUserToGroupDialogProps = {
	name?: string
	header: string
	onSave: (selectedUsersToAdd: Record<string, any>) => void
	onCancel: () => void
	addModalVisibility: boolean
	data: Record<string, any>[]
}

const AddDialogBoxWithDataTable = ({
	name,
	header,
	onSave,
	onCancel,
	addModalVisibility,
	data,
}: IAddUserToGroupDialogProps) => {
	const [selectedUsersToAdd, setSelectedUsersToAdd] = useState<
		Record<string, any>
	>([])

	const [filters, setFilters] = useState<{ [s: string]: any }>()
	const [globalFilterValue, setGlobalFilterValue] = useState("")
	const [first, setFirst] = useState(0); // State to control the first page
	const [sortField, setSortField] = useState(""); // State to control the first page
	const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
	const [rowsPerPage, setRowsPerPage] = useState(5); // State to control the rows per page
	const initFilters = () => {
		setFilters({
			global: { value: null, matchMode: FilterMatchMode.CONTAINS },
		})  
		setGlobalFilterValue("")
	}

	const handleSort = (event: any) => {
		setSortField(event.sortField)
		setSortOrder(event.sortOrder)
		setFirst(0);  //Move to page 1
		// dispatch(setFirstVoice(0)); // Move to page 1
	};
	const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setFirst(0);
		const value = e?.target?.value
		let _filters = { ...filters }

		_filters["global"]!.value = value

		setFilters(_filters)
		setGlobalFilterValue(value)
	}

	useEffect(() => {
		initFilters()
	}, [])
	// if (!data || data.length === 0) return <div></div>
	function capitalize(str: string) {
		if (name === "Users") {
			return str === "id" ? "User ID" : str.charAt(0).toUpperCase() + str.slice(1);
		} else {

			return str === "id" ? str.toUpperCase() : str.charAt(0).toUpperCase() + str.slice(1);
		}
	}

	function convertString(str: string) {
		return str.split('_').map(word => capitalize(word)).join(' ');
	}

	const nameChange = (name: string) => {
		if (name === "Users") {
			return "user"
		} else if (name === "Roles") {
			return "role"
		} else {
			return name
		}
	}
	return (
		<Dialog
			header={header}
			visible={addModalVisibility}
			style={{ width: "940px", maxWidth: "90%" }}
			onHide={() => { onCancel(); initFilters(); setSelectedUsersToAdd([]) }}
		>
			<div className="user-management-section">
				<div className='d-flex align-items-center flex-wrap mb-3'>
					<div className="d-flex justify-content-between align-items-center dialog-filter">
						<div className="d-flex align-items-center mr-3">
							<IconField iconPosition="right" className='user-input'>
								<InputIcon className="pi pi-search"></InputIcon>
								<InputText
									value={globalFilterValue}
									onChange={onGlobalFilterChange}
									placeholder={`Search`}
								/>
							</IconField>
						</div>
						<Button
							className="outline-icon-btn"
							type="button"
							disabled={!selectedUsersToAdd.length}
							onClick={() => {
								onSave(selectedUsersToAdd)
								setSelectedUsersToAdd([])
								initFilters();
							}}
						>
							<i className="pi pi-plus mr-2"></i> Add {name} to the Group
						</Button>
					</div>
				</div>
				<div className="datatable-wrapper">
					<DataTable
						selection={selectedUsersToAdd}
						selectionPageOnly
						onSelectionChange={(e) => setSelectedUsersToAdd(e.value)}
						paginator
						filters={filters}
						globalFilterFields={Object.keys(data[0] ?? {})}
						first={first}
						onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
						rows={rowsPerPage}
						sortField={sortField}
						sortOrder={sortOrder}
						sortMode="single"
						onSort={handleSort}
						rowsPerPageOptions={[5, 10, 25]}
						stripedRows
						value={data}
						emptyMessage={`No ${nameChange(name as string)} records found`}
					>
						<Column
							selectionMode="multiple"
							headerStyle={{ width: "3rem" }}
						></Column>
						{Object.keys(data[0] ?? {}).map((column) => {
							return (
								<Column
									key={column}
									field={column}
									header={convertString(column)}
									sortable
								></Column>
							)
						})}
					</DataTable>
				</div>
			</div>
		</Dialog>
	)
}

export default AddDialogBoxWithDataTable
